<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button parkourBackButton />
    </ion-buttons>

    <ion-title>{{ 'team.team-page.title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <parkour-header-action
        [label]="'team.team-jongere-page.teamlid-add' | translate"
        [link]="['add']"
        icon="plus-circle"
        testId="edit"
      />
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <parkour-page-layout>
    <parkour-page-image
      classes="absolute top-0 left-0 z-0"
      src="/assets/team/background/background_team_blur.jpg"
    />
    <div class="relative z-10 flex flex-col pt-4 pb-8 container container-space gap-y-8">
      <parkour-hero [image]="teamHeroSources">
        <div class="flex flex-col items-center text-center gap-y-4 container-1-col">
          <h1>{{ 'team.team-page.title' | translate }}</h1>

          <parkour-divider />
        </div>
      </parkour-hero>

      <ng-container *parkourSectionContent="{ data: mainPageData$ | async }; let data">
        @if (data.teamleden.length > 0 || data.uitnodigingen.length > 0) {
          <div class="container-1-col flex flex-col gap-y-8">
            <parkour-button class="w-full" iconAfter="plus-circle" link="add">
              {{ 'team.team-jongere-page.teamlid-add' | translate }}
            </parkour-button>
            <!-- TODO: UX Copy team aan JSON toevoegen -->
            <ul class="space-y-2">
              @for (teamlid of data.teamleden; track teamlid) {
                <li>
                  <parkour-teammember-action
                    [link]="'./details/' + teamlid.id"
                    [teamlid]="teamlid"
                  />
                </li>
              }
              @for (uitnodiging of data.uitnodigingen; track uitnodiging) {
                <li>
                  <parkour-teammember-uitnodiging [uitnodiging]="uitnodiging" />
                </li>
              }
            </ul>
          </div>
        } @else {
          <p class="text-center">Voeg teamleden toe om je te ondersteunen.</p>
          <parkour-button class="w-full" iconAfter="plus-circle" link="add">
            Teamlid toevoegen
          </parkour-button>
          <parkour-block-placeholder
            [sources]="{
              default: {
                src: '/assets/team/placeholder/placeholder_team_default.svg',
              },
              md: {
                src: '/assets/team/placeholder/placeholder_team_md.svg',
              },
            }"
            alt=""
            class="block"
          />
        }
      </ng-container>
    </div>
  </parkour-page-layout>
</ion-content>
